module.exports = __webpack_public_path__ + "static/media/delete.538ae97d.mp3";